import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Assets/CSS/login.css';
import "react-phone-input-2/lib/style.css";
import { useNavigate } from 'react-router-dom';
import countries from '../../../Assets/mock_data/Countrycode';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { set } from 'react-hook-form';
import ForgotPassword from '../ForgotPassword/ForgotPassword';
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';


const Login = ({ onClose, loginopen }) => {

  const [selectedCountryCode, setSelectedCountryCode] = useState('+91');
  const [loading, setLoading] = useState(false);
  const [otpButton, setOtpButton] = useState(true)
  const handleCountryCodeChange = (e) => {
    setSelectedCountryCode(e.target.value);
  };
  const location = useLocation()
  const handleForgotPasswordClick = () => {
    navigate('/forgot-password');
    onClose(); // Close the login modal

  };
  const navigate = useNavigate();
  const { login } = useAuth(); // Use login from AuthContext
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(); // Modal visibility state
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [showPhoneOTP, setShowPhoneOTP] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isResendEnabled, setIsResendEnabled] = useState(true);
  const [activeTab, setActiveTab] = useState('password');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpInputs, setOtpInputs] = useState(Array(6).fill(''));
  const [paused, setPaused] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleToggle = () => {
    setIsVisible((prev) => !prev);
  }

    const cookieOptions = {
    //secure: true,
    //sameSite: 'strict',
     sameSite: 'Lax',   // ✅ best choice for HTTP
    path: '/'
  };

  const handleVerifyPhoneClick = () => {
    if (phoneNumber.length === 10) {
      setShowPhoneOTP(true);
      setTimer(600);
      setIsResendEnabled(false);
      setShowOTP(true);
    }
  };

  const otpRefs = useRef([]);

  useEffect(() => {
    let interval = null;
    if (showOTP && timer > 0 && !paused) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else if (timer === 0 || paused) {
      clearInterval(interval);
      setIsResendEnabled(true);
    }

    return () => clearInterval(interval);
  }, [showOTP, timer]);


  const handleTabChange = (newTab) => {
    if (newTab !== activeTab) {
      setActiveTab(newTab);
      setShowPhoneOTP(false);
      setShowOTP(false);
    }
  };

  const handleOtpChange = (index, value) => {
    const newOtpInputs = [...otpInputs];
    newOtpInputs[index] = value.replace(/[^0-9]/g, '');
    setOtpInputs(newOtpInputs);

    if (value && index < otpInputs.length - 1) {
      otpRefs.current[index + 1].focus();
    }
    if (newOtpInputs.every((input) => input !== '')) {
      setPaused(true); // Pause the timer without resetting
    }
  };


  const isOtpComplete = otpInputs.every((input) => input !== '');

  const clickRegister = () => {
    navigate('/register');
    onClose()
  }
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/login`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        const { token, roles, jwtExpirationMs, user } = response.data;
        const userRoles = Array.isArray(roles) ? roles : [roles];
        const isAdmin = userRoles.includes("ROLE_ADMIN");

        Cookies.set('loginOrigin', 'buyer', {
          expires: new Date(Date.now() + jwtExpirationMs),
          sameSite: 'Lax',
          path: '/'
        });

        const cookieOptions = {
          expires: new Date(Date.now() + jwtExpirationMs),
          sameSite: 'Lax',
          path: '/'
        };

        Cookies.set('token', token, cookieOptions);
        Cookies.set('roles', JSON.stringify(userRoles), cookieOptions);
        Cookies.set('jwtExpiration', (Date.now() + jwtExpirationMs).toString(), cookieOptions);
        if (user) {
          Cookies.set('user', JSON.stringify(user), cookieOptions);
        }

        // Set user in AuthContext (this triggers App.js to switch layout)
        const userObj = user ? { ...user, roles: userRoles } : { roles: userRoles };
        login(token, userObj, userRoles);

        toast.success("Login successful!", { duration: 4000 });
        setLoading(false);

        // Redirect based on role (App.js will handle layout switch)
        // if (isAdmin) {
        //   navigate('/admin/dashboard');
        // } else {
        //   navigate('/seller/sellerdashboard');
        // }
        // window.location.reload();
        if (isAdmin) {
          navigate('/admin/dashboard');
        } else if (userRoles.includes("ROLE_SELLER")) {
          navigate('/seller/sellerdashboard');
        } else if (userRoles.includes("ROLE_BUYER")) {
          navigate('/'); // or your buyer dashboard route
        } else {
          navigate('/not-authorized');
        }
        window.location.reload();
        onClose && onClose(false);
      } else {
        setErrorMessage("Enter valid Email and password");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setErrorMessage("Invalid Credentials");
      } else {
        setErrorMessage("Enter valid Email and password. Please try again later.");
      }
      setLoading(false);
      console.error("Error logging in:", error);
    }
  };



  const verifyMobile = async (e) => {

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/send-otp`,
        {
          countryCode: selectedCountryCode,
          mobileNumber: phoneNumber
        },
        {
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );


      toast.success(response.data);
      setShowOTP(true)
      setOtpInputs(Array(6).fill(''))
      setTimer(200);
      setIsResendEnabled(false);
      setShowOTP(true);
    } catch (error) {
      // Check if error response exists
      const errorMessage = error.response
        ? error.response.data.message
        : "Something went wrong!";
      toast.error(error || errorMessage); // Set error state
    }
  }

  const handleLoginWithOtp = async (e) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/login/otp`,
        {
          contryCode: selectedCountryCode,
          mobileNumber: phoneNumber,
          otp: parseInt(otpInputs.join(""), 10)

        },
        {
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );


      if (response.status === 200) {
      
        // Set all authentication data in cookies
      const { token, roles, jwtExpirationMs } = response.data;
        const expirationDate = new Date(Date.now() + jwtExpirationMs);
        
        Cookies.set('token', token, {
          ...cookieOptions,
          expires: expirationDate
        });

        Cookies.set('roles', JSON.stringify(roles), {
          ...cookieOptions,
          expires: expirationDate
        });

        Cookies.set('jwtExpiration', (Date.now() + jwtExpirationMs).toString(), {
          ...cookieOptions,
          expires: expirationDate
        });

        toast.success("Login successful!");

    
        navigate("/");
        onClose(false);
        window.location.reload();
        setLoading(false);
      }
      else {
        setErrorMessage("Enter valid Email and password");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setErrorMessage("Invalid Credentials");
      } else {
        setErrorMessage("Enter valid Email and password. Please try again later.");
      }
      console.error("Error logging in:", error);
    }
  }

  return (

    <>
      {/* Bootstrap Modal */}
      <div
        // className='show d-block'
        className={`modal fade ${loginopen ? 'show d-block' : ''} `}
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content px-5" style={{ borderRadius: '12px' }}>
            {/* <div className="modal-header "> */}
            <div className='modal-body d-flex justify-content-between '>
              <div >
                <h5 className="modal-title">Welcome back</h5>
                <p className="text-muted">Please enter your details to login</p>
              </div>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">


              <div
                className="d-flex justify-content-between mb-3 border rounded-pill"
                style={{ padding: '3px' }}
              >
                <button
                  className={`btn ${activeTab === 'password' ? 'btn-success' : 'btn-outline-light'}`}
                  style={{
                    fontWeight: '500',
                    borderRadius: '20px',
                    color: activeTab === 'password' ? '#371300' : 'black',
                    background: activeTab === 'password' ? '#E7FAFF' : 'transparent',
                    border: activeTab === 'password' ? '1px solid #371300' : 'none',
                  }}
                  onClick={() => handleTabChange('password')}
                >
                  Login with Email
                </button>
                <button
                  className={`btn ${activeTab === 'otp' ? 'btn-success ' : 'btn-outline-light'} `}
                  style={{
                    fontWeight: '500',
                    borderRadius: '20px',
                    color: activeTab === 'password' ? 'black' : '#371300',
                    background: activeTab === 'otp' ? '#E7FAFF' : 'transparent',
                    border: activeTab === 'otp' ? '1px solid #371300' : 'none',
                     
                  }}
                  onClick={() => handleTabChange('otp')}
                >
                  Login with OTP
                </button>

              </div>

              {activeTab === 'password' ? (
                <>
                  {errorMessage && <small className='text-danger'>{errorMessage}</small>}
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label" >Enter registered e-mail id</label>
                    <div className="input-group position-relative">
                      <input type="email"
                        className={`form-control rounded-pill ps-5 ${errorMessage ? "is-invalid" : " "}`}
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="email@domain.com"
                      />
                      <Icon icon="bi:envelope" className="fs-5 text-secondary position-absolute"
                        style={{ left: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: '10' }} />
                    </div>

                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Enter password*</label>
                    <div className="input-group position-relative">
                      <input
                        type={isVisible ? 'text' : 'password'}
                        className={`form-control rounded-pill ps-5 ${errorMessage ? "is-invalid" : " "}`}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        id="password" placeholder="password"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleLogin(e); // pass the event here
                          }
                        }}
                      />
                      <Icon
                        icon="material-symbols:lock-outline"
                        className="fs-5 text-secondary position-absolute"
                        style={{ left: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: '10' }}
                      />
                      <Icon
                        icon={isVisible ? 'bi:eye' : 'bi:eye-slash'}
                        className="fs-5 text-secondary position-absolute"
                        style={{ right: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: '10' }}
                        onClick={handleToggle}
                      />


                      <Icon icon="material-symbols:lock-outline" className="fs-5 text-secondary position-absolute" style={{ left: '20px', top: '50%', transform: 'translateY(-50%)' }} />

                    </div>
                    <span className='forgetPassowrdbtn'
                      onClick={handleForgotPasswordClick}>
                      Forgot Password?
                    </span>
                    {/* {errorMessage && <small className='text-danger'>{errorMessage}</small>} */}

                  </div>
                </>
              ) : (
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">Enter phone*</label>
                  <div className="input-group position-relative">
                    {/* <Icon icon="mdi:web" width="1.2em" height="1.2em"
                      className="fs-5 text-secondary position-absolute"
                      style={{ left: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: 1 }} /> */}
                    <select
                      className="  col-2 rounded mt-2 me-2 px-1"
                      id="country"
                      onChange={handleCountryCodeChange}
                      style={{ border: '0.5px solid #c7c7c7' }}
                    // {...register('country', { required: 'Country is required' })}
                    >
                      {countries.map((country, index) => (
                        <option key={index} value={selectedCountryCode}>{country.value}</option>
                      ))}
                    </select>

                    <input
                      type="text"
                      maxLength={10}
                      className="form-control col-9 rounded mt-2"
                      placeholder="12345 67890"
                      value={phoneNumber}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/\D/g, '') // Remove non-digit characters
                        setPhoneNumber(numericValue)
                        setOtpButton(false)
                      }}

                    />
                  </div>
                </div>
              )}

              {showOTP && (
                <>
                  <p style={{ fontSize: '12px', color: '#909090' }}>Please enter verification code that sent on your mobile number</p>
                  <div className="d-flex justify-content-center gap-2 mt-3">
                    {otpInputs.map((input, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={input}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        className="form-control text-center"
                        ref={(ref) => otpRefs.current[index] = ref}
                        style={{ width: '50px' }}
                      />
                    ))}
                  </div>

                  <div className="d-flex justify-content-between mt-3">
                    <span>Time left: <strong>{Math.floor(timer / 60)}:{String(timer % 60).padStart(2, '0')}</strong></span>
                    <button
                      onClick={verifyMobile}
                      className="btn btn-link"
                      disabled={!isResendEnabled}
                    >
                      Resend OTP
                    </button>
                  </div>
                </>
              )}

              <div className="pt-5">
                {activeTab === "password" && (
                  <button
                    className="btn w-100   text-white rounded-pill"
                    onClick={handleLogin}
                    style={{

                      backgroundColor: "#371300",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1,
                    }}
                  // disabled={loading}
                  >
                    {" Login "}
                  </button>
                )}

                {activeTab === "otp" && !isOtpComplete && (
                  <button
                    className="btn  w-100 text-white rounded-pill"
                    onClick={verifyMobile}
                    style={{

                      backgroundColor: otpButton ? "#808080" : "#371300",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1,
                    }}
                    disabled={otpButton || loading}
                  >
                    {loading ? "Sending OTP..." : "Send OTP"}
                  </button>
                )}

                {activeTab === "otp" && isOtpComplete && (
                  <button
                    className="btn w-100  text-white rounded-pill"
                    onClick={handleLoginWithOtp}
                    style={{
                      backgroundColor: "#371300",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1,
                    }}
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                )}

              </div>

              <div className="text-center mt-3" onClick={clickRegister}>
                <p style={{ color: "#371300", textDecorationLine: 'underline', cursor: 'pointer' }}>
                  Create Account
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* {showForgotPasswordModal && (
        <ForgotPassword onClose={() => setShowForgotPasswordModal(false)} />
      )} */}



      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default Login;


